module.exports = __webpack_public_path__ + "media/images/cert-background-6-1ca3106c2d738a53dc9c6200d905b835.jpg";